import React, { useContext, useEffect, useState } from "react";
import DemoData from "../../data/DemoData";
import BatchItem from "./BatchItem";
import { Link, useParams } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import ENDPOINT from "../../context/EndPoint";
import axios from "axios";
import SecurityHeaders from "../../context/SecurityHeaders";
import GetActiveBatches from "../../actions/course/GetActiveBatches";
import CourseBatchesList from "./CourseBatchesList";
import { useDispatch } from "react-redux";
import { useActionsContext } from "../../context/ActionsContext";

const BatchesList = () => {
  const { user } = useContext(AuthContext);
const dispatch = useDispatch();
  const params = useParams();

  const course_id = params.course_id;
  const { rowsPerPage, setRowsPerPage } = useActionsContext(); 

  const course_url = params.course_url;

  const [category, setcategory] = useState("all");

  const [query, setquery] = useState(null);

  const [batches, setbatches] = useState(null);

  const [snackbar, setsnackbar] = useState(false);
  const [snackbarMessage, setsnackbarMessage] = useState(null);

  const getBatches = async () => {
    dispatch({ type: 'LOADING' });
  
    try {
      const res = await GetActiveBatches({
        payload: {
          session: user.SessionId,
          status: "all",
          limit : rowsPerPage,
        },
      });
  
      if (res?.status === "success") {
        dispatch({ type: 'DONE_LOADING' });
        setbatches(res.data);
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: res?.message || 'Failed to fetch batches' 
        });
      }
    } catch (error) {
      dispatch({ 
        type: 'ERROR', 
        payload: error.message || 'An error occurred while fetching batches' 
      });
    }
  };

  useEffect(() => {
    getBatches();
  }, [rowsPerPage]);

  const updateBatchStatus = async ({ cid, bid, bstatus }) => {
    const formData = new FormData();

    //formData.append('whyus',document.getElementById('whyus').value)

    formData.append("session", user.SessionId);
    formData.append("course_id", cid);
    formData.append("id", bid);
    formData.append("status", bstatus);

    const res = await axios.post(
      ENDPOINT + "admin-update-batch-status.php",
      formData,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
    if (res) {
      if (res.data.status === "success") {
        getBatches();
      } else {
      }
    }
  };

  const options = ["Option 1", "Option 2"];

  const [value, setValue] = React.useState(options[0]);
  const [inputValue, setInputValue] = React.useState("");

  const [delete_id, setdelete_id] = useState(null);

  const DeleteBatch = async ({ id }) => {
    const data = new FormData();
    data.append("session", user.SessionId);
    data.append("id", id);
    const res = await axios.post(
      ENDPOINT + "admin-delete-batch.php",
      data,
      SecurityHeaders
    );

    if (res) {
      if (res.data.status === "success") {
        getBatches();
         // console.log(JSON.stringify(res));
      }
    }
  };

 

  return (
    <>
      <div className="container-fluid ">
     
        <div className="row">
        
               
                  {batches?
                    <CourseBatchesList addbatch={false} batches={batches} />:null}
                    {/* end card */}
                  
              
        </div>

        <div className="row g-0 text-center text-sm-start align-items-center mb-4">
          <div className="col-sm-6">
            <div>
              <p className="mb-sm-0 text-muted">
                Showing <span className="fw-semibold">1</span> to{" "}
                <span className="fw-semibold">10</span> of{" "}
                <span className="fw-semibold text-decoration-underline">
                  12
                </span>{" "}
                entries
              </p>
            </div>
          </div>
          {/* end col */}
          <div className="col-sm-6">
            <ul className="pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
              <li className="page-item disabled">
                <a href="#" className="page-link">
                  Previous
                </a>
              </li>
              <li className="page-item active">
                <a href="#" className="page-link">
                  1
                </a>
              </li>
              <li className="page-item ">
                <a href="#" className="page-link">
                  2
                </a>
              </li>
              <li className="page-item">
                <a href="#" className="page-link">
                  3
                </a>
              </li>
              <li className="page-item">
                <a href="#" className="page-link">
                  4
                </a>
              </li>
              <li className="page-item">
                <a href="#" className="page-link">
                  5
                </a>
              </li>
              <li className="page-item">
                <a href="#" className="page-link">
                  Next
                </a>
              </li>
            </ul>
          </div>
          {/* end col */}
        </div>
        {/* end row */}
      </div>
    </>
  );
};

export default BatchesList;
